export { default } from 'pages/integration';
